import React from 'react';
import { Link } from 'react-router-dom';
import { APP_CONFIG } from '../../../utils/constants';
import styles from './Footer.module.css';

const Footer = () => {
  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        <div className={styles.content}>
          <p className={styles.copyright}>
            © {APP_CONFIG.currentYear} {APP_CONFIG.company}. All rights reserved.
          </p>
          <p className={styles.tagline}>Built by Mutare Labs</p>
          <Link to="/privacy" className={styles.privacyLink}>
            Privacy Policy
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
